import React from 'react'
import { Pane } from 'evergreen-ui'
import { FaCheck } from 'react-icons/fa'
const StatusRegister_1 = ({ DataRegister }) => {
  return (
    <>
      {
        (DataRegister[0].REGISTER_TYPE_ID === "1" || DataRegister[0].REGISTER_TYPE_ID === "5") ?
          (
            <Pane
              color="#fff"
              backgroundColor="#008616ff"
              height="100%"
              paddingY={4}
              paddingX={5}
              fontSize={14}
              fontFamily=""
              margin={0}
              fontWeight={700}
              justifyContent="center"
              alignItems="center"
              display="flex"
              flexDirection="column"
            >
              มีสิทธิ์เข้ารับการสอบสัมภาษณ์
            </Pane>
          ) :
          (<Pane
            color="#fff"
            backgroundColor="#008616ff"
            height="100%"
            paddingY={4}
            paddingX={5}
            fontSize={14}
            fontFamily=""
            margin={0}
            fontWeight={700}
            justifyContent="center"
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
            ชำระค่าสมัครแล้ว
            รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
          </Pane>)
      }


    </>

  )
}

export default StatusRegister_1